export { default } from './PACPInspectionProps.component';
export { getDomainValues as getPACPDomainValues } from './PACPInspectionProps.component';
